<template>
  <div class="speakers">
    <div class="speakers-wrap">
      <small class="slidetop" data-scroll data-scroll-call="animateMove">{{title.en}}</small>
      <strong class="slidetop" data-scroll data-scroll-call="animateMove">{{title.zh}}</strong>
    </div>
  </div>  
</template>

<script>
export default {
  props: {
    title: Object
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/guest/index.less");
</style>